import { registerPlugin } from '@capacitor/core';
export const SocialLoginBase = registerPlugin('SocialLogin', {
    web: () => import('./web').then((m) => new m.SocialLoginWeb()),
});
//# sourceMappingURL=social-login.js.map